export { Register as default } from './Register';
